import { createSlice } from '@reduxjs/toolkit';

const MetierDetailsDataSlice = createSlice({
    name: 'MetierDetailsData',
    initialState: '',
    reducers: {
        setMetierDetailsData: (state, action) => {
            return action.payload;
        },
        resetMetierDetailsData: (state) => {
            return null;
        },
    },
});

export const { setMetierDetailsData, resetMetierDetailsData } = MetierDetailsDataSlice.actions;
export default MetierDetailsDataSlice.reducer;